import { Box, Typography } from "@mui/material";
import { FilledTextArea } from "../../../../components/FilledTextArea";
import { useVerificationContext } from "../../context/useVerification";
import { getParsedTaxId } from "../../utils/getParsedTaxId";
import { parseTaxEntries } from "../../utils/parseTaxEntries";

export const TaxIdDisplay = (props: {
  name: string;
  fields: any;
  label: string;
  disabled?: boolean;
}) => {
  const { fields, name, label, disabled } = props;
  const { countriesRegex } = useVerificationContext();
  const entries = parseTaxEntries(fields[name], "");
  const hasEntries = entries.some((e) => e.country || e.value);

  if (!hasEntries) {
    return (
      <FilledTextArea
        name={name}
        label={label}
        inputProps={{ disabled }}
        value=""
      />
    );
  }

  return (
    <>
      {entries.map((entry, index) => {
        const { viewCountry, check, value, example } = getParsedTaxId(
          entry,
          countriesRegex,
        );
        return (
          <Box key={index}>
            <FilledTextArea
              sx={{
                label: {
                  color:
                    check === "none"
                      ? null
                      : check
                        ? "green !important"
                        : "orange !important",
                },
              }}
              multiline={true}
              name={name}
              label={
                `${viewCountry} ${label}` + (check ? "" : " (check the format)")
              }
              inputProps={{ disabled }}
              value={value ?? ""}
            />
            <Typography variant="caption" paddingLeft="12px">
              {example ?? ""}
            </Typography>
          </Box>
        );
      })}
    </>
  );
};

export const TaxId = TaxIdDisplay;
